/**
 * SMB Component - Overlay
 * @copyright 2019 AVAST Software s.r.o.
 * @author Erik Ondrus
 * @version 1.0
 * @since 2019-08
 *
 * DESCRIPTION:
 * Basic functionality of overlay
 *
 * OPTIONS:
 *
 *
 * USAGE EXAMPLE:
 * <a href="#" data-target-overlay="test">test overlay</a>
 *
 * <div class="overlay" data-overlay="test">
 *  <div class="overlay__content">
 *    <i class="overlay__close">...</i>
 *    ...content
 *  </div>
 * </div>
 *
 */

'use strict';

$(document).ready(function() {
	$(document).on('click', '[data-target-overlay]', function(e){		
		var overlayName = $(this).attr('data-target-overlay');
		var $overlay = $('[data-overlay="' + overlayName + '"]');		
		if (overlayName && overlayName != 'none') {			
			showOverlay($overlay, e);
			playVideo($overlay);
		}		
	});

	$('.overlay, .overlay__close').click(function(data, handler) {
		if (data.target === this) {
			hideOverlay($('.overlay'));
			stopVideo();
		}
	});

	$(document).keyup(function(e) {
		if (e.key === 'Escape') {
			hideOverlay($('.overlay'));
			stopVideo();
		}
	});

	function showOverlay($overlay, e) {
		e.preventDefault();
		$overlay.addClass('overlay_visible');
		$('body').addClass('overlayed');
	}

	function hideOverlay($overlay) {
		$overlay.removeClass('overlay_visible');
		$('body').removeClass('overlayed');
	}

	function playVideo($overlay) {		
		var $el = $overlay.find('.overlay__youtube');
		var src = $el.attr('src');
		$el.attr('src', $el.attr('src')+'&autoplay=1');
	}

	function stopVideo() {				
		$('.overlay__youtube').each(function() {			
			var src = $(this).attr('src');
  			$(this).attr('src', src.replace('&autoplay=1',''));
		});		
	}
});
